import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=ab8ecfe0&"
import script from "./MainPage.js?vue&type=script&lang=js&"
export * from "./MainPage.js?vue&type=script&lang=js&"
import style0 from "./MainPage.scss?vue&type=style&index=0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports